export const PURCHASE_STATUS_NOT_INITIATED = 'NOT_INITIATED';
export const PURCHASE_STATUS_SUCCESS = 'SUCCESS';
export const PURCHASE_STATUS_FAILED = 'FAILED';